// BackButton.js
import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './Style/BackPhone.css';

const Backphone = () => {
    const navigate = useNavigate();
    const location = useLocation();

  if (location.pathname === '/') {
    return null;
  }

    return (
        <div className="fixed-back-button-container">
            <button onClick={() => navigate(-1)} className="back-phone" >
                ⬅
            </button>
        </div>
    );
};

export default Backphone;